(function () {
  'use strict';
  function quantities(value) {
    const steps = Number(value);
    if (String(value).trim() === '' || !Number.isSafeInteger(steps) || steps < 1 || steps > 999) return null;
    return { flooring: Math.ceil(steps / 10), treads: steps, adhesive: Math.ceil(steps / 30) };
  }
  // Export the same calculation used by the storefront for inexpensive boundary tests.
  if (typeof module !== 'undefined' && module.exports) module.exports = { quantities };
  if (typeof document === 'undefined') return;
  function initialise(root) {
    if (root.dataset.bundleReady) return;
    root.dataset.bundleReady = 'true';
    const find = selector => root.querySelector(selector);
    const input = find('[data-bundle-steps]');
    const button = find('[data-bundle-submit]');
    const status = find('[data-bundle-status]');
    const error = find('[data-bundle-error]');
    const cartLink = find('[data-bundle-cart]');
    let config;
    try {
      config = JSON.parse(find('[data-bundle-config]').textContent);
    } catch (_) {
      status.textContent = 'This combination could not be loaded. Please contact us for help.';
      return;
    }
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {
      style: 'currency', currency: config.currency || 'EUR'
    });
    const keys = ['flooring', 'treads', 'adhesive'];
    const labels = { flooring: ['box', 'boxes'], treads: ['stair tread', 'stair treads'], adhesive: ['adhesive tub', 'adhesive tubs'] };
    let busy = false;
    let uncertain = false;
    function variantFor(key) {
      const item = config.items[key];
      const select = find('[data-bundle-variant="' + key + '"]');
      const id = Number(select ? select.value : item.variantId);
      return item.variants.find(variant => variant.id === id);
    }
    function update() {
      const counts = quantities(input.value);
      let total = 0;
      const unavailable = [];
      keys.forEach(key => {
        const item = config.items[key];
        const variant = variantFor(key);
        const available = variant && variant.available;
        if (!available) unavailable.push(item.title);
        const availability = find('[data-bundle-availability="' + key + '"]');
        availability.textContent = available ? '' : (variant ? 'Currently sold out' : 'Matching product unavailable');
        const quantity = counts && counts[key];
        find('[data-bundle-quantity="' + key + '"]').textContent = counts
          ? quantity + ' ' + labels[key][quantity === 1 ? 0 : 1] : 'Enter your step count';
        const lineTotal = variant && counts ? variant.price * quantity : null;
        if (lineTotal !== null) total += lineTotal;
        find('[data-bundle-line-total="' + key + '"]').textContent = lineTotal === null ? '—' : money.format(lineTotal / 100);
        const unitPrice = find('[data-bundle-unit-price="' + key + '"]');
        if (unitPrice && variant) unitPrice.textContent = money.format(variant.price / 100);
      });
      const complete = keys.every(key => variantFor(key));
      find('[data-bundle-total]').textContent = counts && complete ? money.format(total / 100) : '—';
      button.disabled = busy || uncertain || !counts || unavailable.length > 0;
      if (!busy && !uncertain) {
        status.textContent = unavailable.length
          ? 'This combination is currently unavailable: ' + unavailable.join(', ') + '.'
          : counts
            ? counts.flooring + ' ' + labels.flooring[counts.flooring === 1 ? 0 : 1] + ' + ' + counts.treads + ' ' + labels.treads[counts.treads === 1 ? 0 : 1] + ' + ' + counts.adhesive + ' ' + labels.adhesive[counts.adhesive === 1 ? 0 : 1] + '.'
            : input.value ? 'Please enter a whole number of steps between 1 and 999.' : 'Enter your step count to calculate your combination.';
      }
      return counts;
    }
    input.addEventListener('input', () => { error.hidden = true; update(); });
    root.querySelectorAll('[data-bundle-variant]').forEach(select => select.addEventListener('change', update));
    find('[data-bundle-form]').addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || uncertain) return;
      const counts = update();
      if (!counts || button.disabled || !input.reportValidity()) return;
      busy = true;
      update();
      error.hidden = true;
      button.textContent = 'Adding combination…';
      status.textContent = 'Adding all three products to your cart…';
      let confirmedResponse = false;
      try {
        const items = keys.map(key => ({ id: variantFor(key).id, quantity: counts[key] }));
        const base = (config.rootUrl || '/').replace(/\/?$/, '/');
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        confirmedResponse = true;
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : 'The requested quantities are not currently available. Please review your cart before trying again.');
        }
        status.textContent = 'Combination added. Opening your cart…';
        window.location.assign(base + 'cart');
      } catch (failure) {
        uncertain = !confirmedResponse;
        error.textContent = uncertain
          ? 'We could not confirm whether your combination was added. Please check your cart before trying again.'
          : failure.message;
        error.hidden = false;
        cartLink.hidden = false;
        status.textContent = 'Please review the message below.';
        busy = false;
        button.textContent = 'Add combination to cart';
        update();
      }
    });
    update();
  }
  function initialiseAll(scope) {
    if (scope.matches && scope.matches('[data-stairs-bundle]')) initialise(scope);
    scope.querySelectorAll('[data-stairs-bundle]').forEach(initialise);
  }
  initialiseAll(document);
  if (!window.wfsStairsBundleEditorListener) {
    window.wfsStairsBundleEditorListener = true;
    document.addEventListener('shopify:section:load', event => initialiseAll(event.target));
  }
})();